module.exports = __webpack_public_path__ + "img/Logo-Up-MultiBeneficii.f29e5c43.svg";